import i18n from 'src/i18n';
import Tables from 'src/class/Tables';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'date',
      label: i18n.t('common_words.date'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'user.id',
      label: i18n.t('common_words.user'),
      sortable: true,
      minWidth: 150,
      formatter: (row) => {
        return `${row.user.first_name} ${row.user.last_name}`;
      },
    },
    {
      prop: 'farm.name',
      label: i18n.t('common_words.farm'),
      sortable: true,
      minWidth: 150,
    },
    {
      prop: 'lot.name',
      label: i18n.t('common_words.allotment'),
      sortable: true,
      minWidth: 150,
    },
  ];

  return { Table };
};

export default configTable;
